import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const setManuallyChosenSchedules = api(
    async function setManuallyChosenSchedules(id, type, schedule_ids_manual, schedule_id) {
        const variables = { id, type, schedule_ids_manual }
        if (schedule_id !== undefined) {
            variables.schedule_id = schedule_id
        }

        return mutate(
            gql`
                mutation SetManuallyChosenSchedules(
                    $id: String!
                    $type: String!
                    $schedule_ids_manual: [String]
                    $schedule_id: String
                ) {
                    setManuallyChosenSchedules(
                        id: $id
                        type: $type
                        schedule_ids_manual: $schedule_ids_manual
                        schedule_id: $schedule_id
                    )
                }
            `,
            variables,
            { returns: "setManuallyChosenSchedules" }
        )
    }
)
